import React from 'react';
import ReactDOM from 'react-dom';

import { IndexJs } from '@westernmilling/eu_react_shared';
import App from 'App';
import 'i18n';

ReactDOM.render(<IndexJs app={<App />} />, document.getElementById('root'));
